import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import AppliedFilters from '../facets/applied-filters';
import FiltersModal from './filters-modal';
import SortModal from './sort-modal';

class MobileSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFiltersModal: false,
      showSortModal: false,
    };
  }

  render() {
    return (
      <div className="col-sm-12 hidden-lg hidden-xl">
        <div className="row">
          <div className="col-xs-6 ">
            <a className="btn btn-default btn-block" onClick={() => this.setState({ showFiltersModal: true })}>
              <FormattedMessage id="filters.modal.openButton"/>
            </a>
          </div>
          <div className="col-xs-6 ">
            <a className="btn btn-default btn-block" onClick={() => this.setState({ showSortModal: true })}>
              <FormattedMessage id="sort.modal.openButton"/>
            </a>
          </div>
        </div>
        <AppliedFilters {...this.props} />
        <FiltersModal
          {...this.props}
          showModal={this.state.showFiltersModal}
          onClose={() => this.setState({ showFiltersModal: false })}
        />
        <SortModal
          {...this.props}
          showModal={this.state.showSortModal}
          onClose={() => this.setState({ showSortModal: false })}
        />
      </div>
    );
  }
}

export default MobileSidebar;



// WEBPACK FOOTER //
// ./src/views/recalls-list/side-bar/mobile.js